module.exports = __webpack_public_path__ + "static/img/car009.07f6d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/car009.png
// module id = +XmU
// module chunks = 37